import React from 'react';

import {
  Action,
  Actions,
  MoreVertIcon,
  FileDownloadIcon,
  ActionBar,
} from '@gogame/components';
import { FullScreenToggler } from '@gogame/data-grid';
import { useChildComponent } from '@gogame/hooks-ts';
import { SearchField, useScreenState, useScreenTitle } from '@gogame/screens';

import Departments from 'scenes/Users/AdminUsers/Departments';
import Positions from 'scenes/Users/AdminUsers/Positions';
import { UserFormCreate } from 'scenes/Users/AdminUsers/components/UserForm';
import { useExportUsers } from 'scenes/Users/AdminUsers/data/mutations';

export default () => {
  const [childComponent, openChildComponent] = useChildComponent();

  const [screenTitle] = useScreenTitle();
  const screenState = useScreenState();

  const [exportUsers] = useExportUsers();

  const handleExport = async () => {
    await exportUsers({
      filters: screenState.filters,
      tableSettings: screenState.tableSettings,
      searchQuery: screenState.searchQuery,
    });
  };

  const handleOpenPositions = () => {
    openChildComponent(Positions);
  };

  const handleOpenDepartments = () => {
    openChildComponent(Departments);
  };

  const handleCreate = () => {
    openChildComponent(UserFormCreate);
  };

  return (
    <>
      <ActionBar
        title={screenTitle}
        search={
          <SearchField
            tooltip={'Search by comma separated values is supported'}
          />
        }
        secondaryActions={
          <Actions>
            <Action
              icon={<FileDownloadIcon />}
              onClick={handleExport}
              tooltip={'Export Users'}
            />
            <Action component={FullScreenToggler} />
            <Action icon={<MoreVertIcon />} tooltip={'More'}>
              <Action
                button
                label={'Manage departments'}
                onClick={handleOpenDepartments}
              />
              <Action
                button
                label={'Manage positions'}
                onClick={handleOpenPositions}
              />
            </Action>
          </Actions>
        }
        primaryActions={
          <Actions>
            <Action
              border={true}
              button={true}
              add={true}
              iconContent={true}
              tooltip={'Add User'}
              variant={'outlined'}
              onClick={handleCreate}
            />
          </Actions>
        }
      />
      {childComponent}
    </>
  );
};
